import { render, staticRenderFns } from "./video-box.vue?vue&type=template&id=47088f3a&scoped=true&"
import script from "./video-box.vue?vue&type=script&lang=js&"
export * from "./video-box.vue?vue&type=script&lang=js&"
import style0 from "./video-box.vue?vue&type=style&index=0&id=47088f3a&prod&scoped=true&lang=scss&"
import style1 from "./video-box.vue?vue&type=style&index=1&id=47088f3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47088f3a",
  null
  
)

export default component.exports